import React    from 'react'

import logo from 'assets/logo.png';
import fci_logo from 'assets/fci_logo.jpg';
import './RegistrationRequestPrint.sass';

import { prepareUrl } from 'services/DataSource';
import RegistrationRequest from 'services/RegistrationRequest';
import Show                from 'services/Show';
import { formatDate }      from 'services/utils';
import { showClasses, dogSexes } from 'services/constants';
import { Spinner } from 'components/atoms';

import PrinterSelect from 'components/PrinterSelect';
import PrintButton from 'components/PrintButton';

const extensions = ['jpg', 'jpeg', 'png', 'tiff'];

function docTypeFilter(doc) {
  if (!doc || !doc.name || !doc.url) return false; 
  let ext = doc.name.split('.').pop();
  return extensions.includes(ext);
}


export default class RegistrationRequestPrint extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      item: null,
      shows: null,
      itemId: match.params.id,
    }
    this.mounted = false
  }

  componentDidMount() {
    this.mounted = true;
    this.loadItem();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadItem = () => {
    this.setState({loading: true});
    RegistrationRequest.get(this.state.itemId).then((item) => {
      if (!this.mounted) return false;
      if (!item.register_to) item.register_to = [];
      if (!item.register_to.push) {
        item.register_to = Object.values(item.register_to);
      }
      item.register_to = item.register_to
        .filter(rdata => rdata.class_in_show && rdata.submitted !== 'false' && rdata.submitted !== false)
      this.setState({ item });
      this.loadShows(item.register_to.map(data => data.show_id));
    }).catch(alert);
  }

  loadShows(ids) {
    if (ids && ids.length) {
      Show.query({ids}).then(result => {
        if (!this.mounted) return false;
        this.setState({
          shows: result.items,
          loading: false
        });
      });
    } else {
      this.setState({
        shows: [],
        loading: false
      });
    }
  }
  handleChange = () => {
    this.setState({item: this.state.item});
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  render() {
    const {item, shows, loading} = this.state;
    
    if (loading) return <Spinner />;
    if (!item) return <p>Нет данных по заявке.</p>;
    if (!shows || !shows.length) return <p>Нет открытых выставок.</p>;

    return (
      <div className="container-fluid">
        
        <div className="row no-print">
          <div className="col-2">
            <label>Принтер</label>
            <PrinterSelect className="form-control" orientation="portrait"/>
          </div>
          <div className="col-1">
            <label className="row">&nbsp;</label>
            <PrintButton />
          </div>
          <div className="col-9">
            { [...item.doc_pedigree, ...item.doc_certificate, item.doc_receipt]
              .filter(docTypeFilter)
              .map(doc => {
                if (!doc) return null
                return <label key={doc.name} className="m-2">
                  <input type="checkbox" name={doc.name} checked={!doc.hide} className="m-2"
                   onChange={({target}) => {
                    doc.hide = !target.checked;
                    this.handleChange();
                  }} /> 
                  {doc.name} 
                </label>
              }) 
            }
          </div>
        </div>

        <div className="print-page">
          <div className="header">
            <img src={logo} className="bcu-logo"  height="100" width="100" alt="BKO logo" />
            <h2>СОЮЗ ОБЩЕСТВЕННЫХ ОБЪЕДИНЕНИЙ <br />
            БЕЛОРУССКОЕ КИНОЛОГИЧЕСКОЕ ОБЪЕДИНЕНИЕ</h2>
            <img src={fci_logo} className="fci-logo"  height="100" width="100" alt="FCI logo"/>
          </div>
          <h3 className="show-title">2xМеждународная выставка собак всех пород 
          /2xInternational dog show C.A.C.I.B. FCI
          Национальная выставка собак всех пород / 
          National dog show C.A.C.I.B. BLR</h3>
          
          {item.register_to.map(rdata => {
            let show = shows.find(show => show.id === +rdata.show_id);
            if (!show || !rdata.class_in_show) return null;
            let showClass = showClasses.find(sclass => sclass.id === +rdata.class_in_show);
            if (!showClass) return null;
            return <div className="show" key={show.id}>
              <strong>{show.name}</strong> - <span>{formatDate(show.starts_at)}</span>, 
              в {showClass.name}
            </div>
          })}

          <ul className="dog-data">
            <li>
              <label>Порода</label>
              <span>{item.breed_name}</span>
            </li>
            <li>
              <label>Пол</label>
              <span>{dogSexes[item.sex]}</span>
            </li>
            <li>
              <label>Окрас</label>
              <span>{item.color}</span>
            </li>
            <li>
              <label>Кличка собаки</label>
              <span className="big">{item.name}</span>
            </li>
            <li>
              <label>Номер родословной</label>
              <span className="big">{item.pedigree}</span>
            </li>
            <li>
              <label>Дата рождения</label>
              <span>{formatDate(item.date_of_birth)}</span>
            </li>
            <li>
              <label>Титулы или испытания</label>
              <span className="big">{item.titles}</span>
            </li>
            <li>
              <label>Отец</label>
              <span className="big">{item.father_name}</span>
            </li>
            <li>
              <label>Мать</label>
              <span className="big">{item.mother_name}</span>
            </li>
            <li>
              <label>Заводчик</label>
              <span>{item.breeder_name}</span>
            </li>
            <li>
              <label>Владелец</label>
              <span>{item.owner_name}</span>
            </li>
            <li>
              <label>Email</label>
              <span>{item.owner_email}</span>
            </li>
            <li>
              <label>Телефоны</label>
              <span>{item.owner_phone}</span>
            </li>
            <li>
              <label>Дата подачи</label>
              <span>{formatDate(item.created_at)}</span>
            </li>
          </ul>
        </div>
        <Documents docs={item.doc_pedigree} onChange={this.handleChange}/>
        <Documents docs={item.doc_certificate} onChange={this.handleChange}/>
        <Document doc={item.doc_receipt} onChange={this.handleChange}/>
      </div>
    );
  }

}

function Documents({docs, onChange}) {
  if (!docs || !docs.length) return null;
  return docs.filter(docTypeFilter)
    .map(doc => <Document key={doc.id} doc={doc} onChange={onChange}/>)
    .filter(item => item);
}

function Document({doc, onChange}) {
  if (!doc || !doc.url || doc.hide) return null;
  return <div className="print-page doc">
    <div className="no-print">
      <label key={doc.name} className="m-2">
        <input type="checkbox" name={doc.name} checked={true} className="m-2"
         onChange={({target}) => {
          doc.hide = true;
          onChange();
        }} /> 
        {doc.name} 
      </label>
    </div>
    <img className="doc" src={prepareUrl(doc.url, true)} alt={doc.name} />
  </div>;
}


